export default "__VITE_ASSET__1CGpOH$J__"